import { useLocalStore, useObserver } from 'mobx-react-lite';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { AddressContainerProps } from '../types/AddressContainerProps';
import AddressDisplay from './AddressDisplay';
import AddressSelect from './AddressSelect';
import AddressDisplayV2 from './AddressDisplayV2';
import AddressSelectV2 from './AddressSelectV2';
import { VersionProps } from '../types/VersionProps';

const UnstyledAddressContainer: React.FC<
  AddressContainerProps & VersionProps
> = ({ className, version, ...addressDisplayProps }) => {
  const [isEditing, setIsEditing] = useState(false);
  const state = useLocalStore(() => ({
    onEditAddressComplete() {
      setIsEditing(false);
    },
    onEditAddress() {
      setIsEditing(true);
    },
  }));

  const versionCssClasses = version === 2 ? 'text-base' : '';

  return useObserver(() => (
    <div
      className={`ww-widget ww-address-select ${versionCssClasses} ${
        className || ''
      }`}
    >
      {version === 2 ? (
        isEditing ? (
          <AddressSelectV2
            onEditAddressComplete={state.onEditAddressComplete}
          />
        ) : (
          <AddressDisplayV2
            onEditAddress={state.onEditAddress}
            {...addressDisplayProps}
          />
        )
      ) : isEditing ? (
        <AddressSelect onEditAddressComplete={state.onEditAddressComplete} />
      ) : (
        <AddressDisplay
          onEditAddress={state.onEditAddress}
          {...addressDisplayProps}
        />
      )}
    </div>
  ));
};

const AddressContainer = styled(UnstyledAddressContainer)``;

export default AddressContainer;
